import { ContentFieldType } from "../../../types/cms/contentField.type";
import { getPublishedPlans } from "../../subscription/plans";
import type { PublishedSubscriptionPlan } from "../../subscription/types";
import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { resolvePath } from "../internal/resolvePath";
import type { InterpolateParams } from "../types";

export function extractPlans({
  structure,
  template,
}: InterpolateParams): PublishedSubscriptionPlan[] {
  const match = template.match(SINGLE_TOKEN_REGEX);
  if (!match) return [];

  const [, path, type] = match;
  if (type !== ContentFieldType.SUBSCRIPTION_PLANS) return [];

  return getPublishedPlans(resolvePath(structure, path));
}
